import moment from 'moment'
import React from 'react'
import { maskString } from 'utils/functions'

import _ from 'lodash'
import Container from './styles'

function ApplicantInfo(props) {
  const { applicantData, creationDate } = props
  return (
    applicantData && (
      <Container>
        <p>
          <span>CPF: </span>
          {maskString(applicantData?.cpf, 'cpf')}
        </p>
        <p className="name">
          <span>Nome: </span>
          {applicantData?.name?.toLowerCase()}
        </p>
        <p>
          <span>Data de Nascimento: </span>
          {_.isEmpty(applicantData?.birth_date) ?  '-' : moment(applicantData?.birth_date).format('DD/MM/yyyy')}
        </p>
        <p>
          <span>Data de derivação para revisão: </span>
          {_.isEmpty(creationDate) ?  '-' : moment(creationDate).format('DD/MM/yyyy HH:mm:ss')}
        </p>
      </Container>
    )
  )
}

export default ApplicantInfo
